import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../PasswordProtectionUnlock.module.scss';

interface IChallengeDescriptionProps {
  readonly challengeValue: string;
}

export const ChallengeDescription: React.FC<IChallengeDescriptionProps> = ({
  challengeValue,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.challengeDescription}>
      {t('blockPage.unlock.challengeInstruction')}&nbsp;
      <span className={styles.challengeDescriptionBold}>
        {challengeValue}&nbsp;
      </span>
      {t('blockPage.unlock.challengeIn')}&nbsp;
      <span className={styles.challengeDescriptionBold}>
        {t('blockPage.unlock.challengeAllCaps')}
      </span>
    </div>
  );
};
